import { Box } from "@mui/material";
import style from "./style.module.scss";
export default function GraySpinner() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: "24px 0" }}>
      <span className={`${style.loader} ${style.gray}`}></span>
    </Box>
  );
}
